<div class="demooz_card" 
     [class.with_margin]="this.withMargin"
     [class.full_height]="this.fullHeight"
     >    
    <div class="demooz_card_header">
        <ng-content select="[card_header]"></ng-content>
    </div>
    <div class="demooz_card_body">
        <ng-content></ng-content>
    </div>
</div>
